var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (group, identifiable, identifiableName, isGroup, query, results, undefined) {
buf.push("<ul class=\"search__results__list\">");
// iterate results
;(function(){
  var $$obj = results;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var result = $$obj[$index];

switch (result.get('class')){
case 'User':
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>" + (jade.escape(null == (jade_interp = result.get('username')) ? "" : jade_interp)) + "</li></ul></a></li>");
  break;
case 'Channel':
isGroup = result.has('group') && result.get('group').id
identifiable = isGroup ? result.get('group') : result.get('user')
identifiableName = isGroup ? identifiable.name : identifiable.username
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (identifiable.slug) + "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>");
if ( isGroup)
{
buf.push(jade.escape(null == (jade_interp = identifiableName) ? "" : jade_interp));
group = identifiable
buf.push("<div class=\"GroupBadge\"><div class=\"GroupBadge__inner\">");
if(group && group.visibility === 1)
{
buf.push("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\">\n  <path d=\"M.992 20h15.016a.991.991 0 0 0 .992-.987v-9.46a.985.985 0 0 0-.992-.982h-.956V7.192c0-1.853-.717-3.91-1.886-5.152C12.002.8 10.333 0 8.504 0H8.5h-.004C6.667 0 4.998.8 3.834 2.036c-1.169 1.24-1.886 3.299-1.886 5.152V8.57H.992A.988.988 0 0 0 0 9.554v9.46c0 .544.443.986.992.986zM4.294 7.192c0-1.219.439-2.728 1.244-3.585v-.013c.78-.83 1.855-1.317 2.958-1.317h.008c1.103 0 2.179.486 2.958 1.317v.009l-.005.004c.81.857 1.244 2.366 1.244 3.585v1.38H4.295v-1.38z\" />\n</svg>\n");
}
buf.push("<span>GROUP</span></div></div>");
}
else
{
buf.push(jade.escape(null == (jade_interp = identifiableName) ? "" : jade_interp));
}
buf.push("</li><li" + (jade.cls(["search__results__result--privacy-" + (result.getVisibility()) + ""], [true])) + ">" + (jade.escape(null == (jade_interp = result.get('title')) ? "" : jade_interp)) + "</li></ul></a></li>");
  break;
case 'Group':
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>" + (jade.escape(null == (jade_interp = result.get('name')) ? "" : jade_interp)) + "<div class=\"GroupBadge\"><div class=\"GroupBadge__inner\">");
if(group && group.visibility === 1)
{
buf.push("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\">\n  <path d=\"M.992 20h15.016a.991.991 0 0 0 .992-.987v-9.46a.985.985 0 0 0-.992-.982h-.956V7.192c0-1.853-.717-3.91-1.886-5.152C12.002.8 10.333 0 8.504 0H8.5h-.004C6.667 0 4.998.8 3.834 2.036c-1.169 1.24-1.886 3.299-1.886 5.152V8.57H.992A.988.988 0 0 0 0 9.554v9.46c0 .544.443.986.992.986zM4.294 7.192c0-1.219.439-2.728 1.244-3.585v-.013c.78-.83 1.855-1.317 2.958-1.317h.008c1.103 0 2.179.486 2.958 1.317v.009l-.005.004c.81.857 1.244 2.366 1.244 3.585v1.38H4.295v-1.38z\" />\n</svg>\n");
}
buf.push("<span>GROUP</span></div></div></li></ul></a></li>");
  break;
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var result = $$obj[$index];

switch (result.get('class')){
case 'User':
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>" + (jade.escape(null == (jade_interp = result.get('username')) ? "" : jade_interp)) + "</li></ul></a></li>");
  break;
case 'Channel':
isGroup = result.has('group') && result.get('group').id
identifiable = isGroup ? result.get('group') : result.get('user')
identifiableName = isGroup ? identifiable.name : identifiable.username
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (identifiable.slug) + "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>");
if ( isGroup)
{
buf.push(jade.escape(null == (jade_interp = identifiableName) ? "" : jade_interp));
group = identifiable
buf.push("<div class=\"GroupBadge\"><div class=\"GroupBadge__inner\">");
if(group && group.visibility === 1)
{
buf.push("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\">\n  <path d=\"M.992 20h15.016a.991.991 0 0 0 .992-.987v-9.46a.985.985 0 0 0-.992-.982h-.956V7.192c0-1.853-.717-3.91-1.886-5.152C12.002.8 10.333 0 8.504 0H8.5h-.004C6.667 0 4.998.8 3.834 2.036c-1.169 1.24-1.886 3.299-1.886 5.152V8.57H.992A.988.988 0 0 0 0 9.554v9.46c0 .544.443.986.992.986zM4.294 7.192c0-1.219.439-2.728 1.244-3.585v-.013c.78-.83 1.855-1.317 2.958-1.317h.008c1.103 0 2.179.486 2.958 1.317v.009l-.005.004c.81.857 1.244 2.366 1.244 3.585v1.38H4.295v-1.38z\" />\n</svg>\n");
}
buf.push("<span>GROUP</span></div></div>");
}
else
{
buf.push(jade.escape(null == (jade_interp = identifiableName) ? "" : jade_interp));
}
buf.push("</li><li" + (jade.cls(["search__results__result--privacy-" + (result.getVisibility()) + ""], [true])) + ">" + (jade.escape(null == (jade_interp = result.get('title')) ? "" : jade_interp)) + "</li></ul></a></li>");
  break;
case 'Group':
buf.push("<li class=\"search__results__result\"><a" + (jade.attr("href", "/" + (result.get('slug')) + "", true, true)) + "><ul class=\"breadcrumb\"><li>" + (jade.escape(null == (jade_interp = result.get('name')) ? "" : jade_interp)) + "<div class=\"GroupBadge\"><div class=\"GroupBadge__inner\">");
if(group && group.visibility === 1)
{
buf.push("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\">\n  <path d=\"M.992 20h15.016a.991.991 0 0 0 .992-.987v-9.46a.985.985 0 0 0-.992-.982h-.956V7.192c0-1.853-.717-3.91-1.886-5.152C12.002.8 10.333 0 8.504 0H8.5h-.004C6.667 0 4.998.8 3.834 2.036c-1.169 1.24-1.886 3.299-1.886 5.152V8.57H.992A.988.988 0 0 0 0 9.554v9.46c0 .544.443.986.992.986zM4.294 7.192c0-1.219.439-2.728 1.244-3.585v-.013c.78-.83 1.855-1.317 2.958-1.317h.008c1.103 0 2.179.486 2.958 1.317v.009l-.005.004c.81.857 1.244 2.366 1.244 3.585v1.38H4.295v-1.38z\" />\n</svg>\n");
}
buf.push("<span>GROUP</span></div></div></li></ul></a></li>");
  break;
}
    }

  }
}).call(this);

buf.push("<li class=\"search__results__result search__results__see-all\"><a" + (jade.attr("href", "/search/" + (query) + "", true, true)) + ">See all results</a></li></ul>");}.call(this,"group" in locals_for_with?locals_for_with.group:typeof group!=="undefined"?group:undefined,"identifiable" in locals_for_with?locals_for_with.identifiable:typeof identifiable!=="undefined"?identifiable:undefined,"identifiableName" in locals_for_with?locals_for_with.identifiableName:typeof identifiableName!=="undefined"?identifiableName:undefined,"isGroup" in locals_for_with?locals_for_with.isGroup:typeof isGroup!=="undefined"?isGroup:undefined,"query" in locals_for_with?locals_for_with.query:typeof query!=="undefined"?query:undefined,"results" in locals_for_with?locals_for_with.results:typeof results!=="undefined"?results:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;